import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const SpecialSession = () => {
  const show = true;
  if (show) {
  return (
    <React.Fragment>
      <SEO title="Special Sessions | DMBD 2026" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2-opt.jpg"
        title="Special Sessions"
        content="For Authors"
        contentTwo="Special Sessions"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          {/* <h2 id="session1">SS1: Innovations in Big Data Processing and AI: Challenges, Architectures, and Applications</h2>
          <p className="home-p text-justify">

            Rapid advancements in big data and artificial intelligence technologies have had a profound impact
            on all areas of human society including the economy, management, politics, healthcare, and education.
            Big data analytics employs a variety of artificial intelligence techniques including machine learning,
            deep learning, computational optimization, evolutionary computation, and swarm intelligence.
            The special session aims at presenting the latest developments of the artificial intelligent algorithms
            in data mining, discussing the future direction of developments, and exchanging novel ideas about
            how to overcome the challenges.
            It welcomes the original contributions that provide novel theories, frameworks and applications to algorithms.
            <br></br>
            <h4>Topics of Interest</h4>
            Topics of interest include, but are not limited to:
            <ul>
            <li>Advanced Techniques for Big Data Analytics</li>
            <li>Deep Learning Architectures for Big Data</li>
            <li>Privacy and Security in Large-Scale Data Processing</li>
            <li>Online and Adaptive Learning for Streaming Data</li>
            <li>Generative Models and Large-Scale AI Systems</li>
            <li>Utilizing large-scale generative models for diverse applications.</li>
            <li>The role of generative adversarial networks (GANs) in Big Data and AI research.</li>
            <li>Clustering, Classification, and Prediction in Big Data</li>
            <li>Predictive analytics and its impact on decision-making across various domains.</li>
            <li>Big Data Architectures and System Design</li>
            <li>Tools and technologies for improving the quality of service (QoS) in Big Data processing.</li>
            <li>Applications of Big Data and AI in Emerging Technologies</li>
            <li>Case studies showcasing the impact of Big Data analytics on emerging technologies.</li>
            </ul>

            <h4>Submission</h4>
            Please follow the DMBD&apos;2024 instruction for authors and submit your paper via the DMBD&apos;2024
            online submission system. Please specify that your paper is for &quot; SS1--Innovations in Big Data Processing and AI: Challenges, Architectures, and Applications &quot; in your paper.
          </p>

          <h4>Organizers</h4>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Affiliate</th>
                <th scope="col">Email</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="align-middle">Prof. Arun Sharma</td>
                <td className="align-middle">Information Technology Indira Gandhi Delhi Technical University for Women, Delhi</td>
                <td className="align-middle"></td>
              </tr>
              <tr>
                <td className="align-middle">Dr. Ritu Rani</td>
                <td className="align-middle">Guru Gobind Singh Indraprastha University, Delhi</td>
                <td className="align-middle">ritujangra00@gmail.com</td>
              </tr>
              <tr>
                <td className="align-middle">Dr. Garima Jaiswal</td>
                <td className="align-middle">Bennett University, India</td>
                <td className="align-middle"></td>
              </tr>
            </tbody>
          </table>
          <br></br>
          <hr></hr> */}

          <h2 id="session1">SS1: Big Data Mining and Foundation Models for Explainable Multimodal Diagnosis in Precision Healthcare</h2>
          <p className="home-p text-justify">
          <p>Modern healthcare systems generate enormous volumes of heterogeneous data every day, medical images (MRI, CT, X-ray), electronic health records, genomic profiles, wearable sensor streams, and unstructured clinical text. Extracting reliable, timely, and clinically meaningful insight from this data deluge is a big defining data challenge of the decade, and one where data mining, deep learning, and, increasingly, foundation models and large language models (LLMs) are converging. </p>
          <p>While deep learning has driven major advances in medical image classification and disease detection, most existing systems still operate on a single data modality and offer limited transparency into how a diagnosis is reached. Clinicians, however, need models that can fuse multiple sources of big data (imaging, text, structured records) and explain their reasoning in a way that supports, rather than replaces, clinical judgment. At the same time, the rise of foundation models and multimodal LLMs opens new possibilities for building unified, adaptable diagnostic pipelines that can be fine-tuned or prompt-tuned across institutions and disease types, while federated and privacy-preserving learning approaches are becoming essential for mining sensitive medical big data across hospitals without compromising patient privacy.</p>
          <p>This special session brings together researchers working at the intersection of data mining, big data infrastructure, and AI/foundation models to address a central question: how can we mine, fuse, and reason over large-scale, multimodal healthcare data to produce diagnostic systems that are accurate, scalable, and explainable? The session directly extends DMBD&apos;2026 core themes, Big Data, Machine Learning, Foundation Models, and Applications (Intelligent Diagnosis), into a focused, application-driven track on next-generation medical big data analytics.</p>

            <br></br>
            <h4>Topics of Interest</h4>
            Topics of interest for this special session include, but are not limited to:
            <ul>
            <li>Big data mining techniques for multimodal medical imaging (MRI, CT, X-ray, ultrasound)</li> <li>Deep learning architectures (CNNs, Transformers, hybrid models) for large-scale medical image classification and segmentation</li> <li>Foundation models and LLMs for clinical decision support and diagnostic reasoning</li> <li>Multimodal fusion of imaging, electronic health records, and genomic big data</li> <li>Explainable AI (XAI) methods for trustworthy, interpretable medical diagnosis</li> <li>Federated learning and privacy-preserving analytics for multi-institutional medical big data</li> <li>Transfer learning and few-shot learning for rare disease and chronic disease detection</li> <li>AI agents and automated pipelines for intelligent diagnosis and chronic disease management</li> <li>Anomaly and disease-pattern detection in large-scale healthcare datasets</li> <li>Synthetic data generation and augmentation for medical big data</li> <li>Benchmark datasets and evaluation frameworks for medical AI systems</li> <li>Case studies and applications: brain tumor detection, lung cancer diagnosis, cardiovascular risk prediction, and other intelligent diagnosis tasks driven by big data mining</li>
            </ul>

            <h4>Submission</h4>
            Please follow the DMBD&apos;2026 instruction for authors and submit your paper via the DMBD&apos;2026
            online submission system. Please specify that your paper is for &quot;SS1: Big Data Mining and Foundation Models for Explainable Multimodal Diagnosis in Precision Healthcare&quot; in your paper.
          </p>

          <h4>Organizers</h4>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Affiliate</th>
                <th scope="col">Email</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="align-middle">Muhammad Aamir</td>
                <td className="align-middle">	Huanggang Normal University</td>
                <td className="align-middle">aamirshaikh86@hotmail.com</td>
              </tr>
              <tr>
                <td className="align-middle">Uzair Aslam Bhatti</td>
                <td className="align-middle">	Hainan University</td>
                <td className="align-middle">	184311@hainanu.edu.cn</td>
              </tr>

            </tbody>
          </table>

          <br></br>
          <hr></hr>

          
          <div className="call-sp">


            <h2 id="callforss">DMBD 2026 Call for Special Session Proposals</h2>
            <br></br>
            <p align="justify">
              DMBD 2026 technical program will include special sessions. Their aim is to provide a
              complementary flavor to the regular sessions and should include hot topics of interest
              to the data mining and big data community that may also go beyond disciplines traditionally
              represented at DMBD.
            </p>

            <p align="justify">
              Prospective organizers of special sessions should submit proposals indicating:
              <ul >
                <li>Title of the session.</li>
                <li>Rationale of the need for the special session at DMBD.</li>
                <li>The rationale should stress the novelty of the topic and/or its multidisciplinary
                  flavor, and must explain how it is different from the subjects covered by the
                  regular sessions.</li>
                <li>Short biography of the organizers.</li>
                <li>List of 5 – 6 contributed papers (including titles, authors, contact information of
                  the corresponding author) (this can also be provided later when they become
                  available).</li>
              </ul>
            </p>


            <p align="justify">
              Proposals are due on or before 	September 6th, 2026 and should be sent via e-mail (in
              either
              pdf
              or plain ASCII text form) to the special sessions chair (to be announced) and forward to
              DMBD 2026 secretariat at <a href="mailto: dmbd2026@iasei.org">dmbd2026@iasei.org</a>.
            </p>

            <p align="justify">

              Proposals will be evaluated based on the timeliness of the topic, the qualifications of
              the
              organizers and the authors of the papers proposed in the session. In its decision, the
              committee will try to realize a balance of the topics across the technical areas
              represented
              data mining and big data.

            </p>

            <p align="justify">
              Notification of acceptance will be sent to the organizers no later than September 20th, 2026.
              Authors of papers included in approved special sessions should submit their manuscript
              on or  before September 31st, 2026. Manuscripts should conform to the formatting and electronic
              submission guidelines of regular DMBD papers (Springer’s CCIS format).
            </p>

            <p align="justify">
              When they submit papers, there is a choice to indicate that their papers are special
              session
              papers which will also undergo peer review. It is the responsibility of the organizers
              to
              ensure that their special session meets the DMBD quality standards. If, at the end of
              the
              review process, less than four papers are accepted, the session will be canceled and the
              accepted papers will be moved to regular sessions.
            </p>


          </div>

        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
  }
  else {
    return (
      <React.Fragment>
      <SEO title="Special Sessions | DMBD 2026" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2-opt.jpg"
        title="Special Sessions"
        content="For Authors"
        contentTwo="Special Sessions"
        linkage="/"

      />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div>
            <h4>To be released.</h4>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    )
  }
};

export default SpecialSession;
